export default function ChevronRightV2({
  width = 6,
  height = 10,
  fill = 'currentColor',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M-0.00387944 9.00311C-0.00382318 8.73759 0.101703 8.48296 0.289487 8.29523L3.58661 4.99811L0.289487 1.70098C0.107101 1.51215 0.00618078 1.25923 0.00846196 0.996702C0.0107431 0.734177 0.116044 0.483051 0.301684 0.29741C0.487324 0.11177 0.738451 0.00646957 1.00098 0.0041883C1.2635 0.00190703 1.51642 0.102828 1.70526 0.285214L5.71026 4.29022C5.89797 4.47798 6.00342 4.73261 6.00342 4.99811C6.00342 5.2636 5.89797 5.51823 5.71026 5.70599L1.70526 9.711C1.56523 9.85098 1.38684 9.94631 1.19265 9.98492C0.998452 10.0235 0.797167 10.0037 0.614239 9.92795C0.43131 9.85218 0.274952 9.72388 0.16493 9.55927C0.0549079 9.39465 -0.00383748 9.20111 -0.00387944 9.00311Z'
        fill={fill}
      />
    </svg>
  );
}
